<!--
 * @Autor: Sakurag1_LSJ
 * @LastEditors: Lvshijie
-->
<template>
  <div>
    <div class="tool">
      <div class="tool-up">
        <div style="margin-top: 20px">
          <div style="width: 100%">
            <!-- 输入数据模式 -->
            <el-row type="flex" justify="center">
              <el-col :span="12">
                <el-card class="cardModel" style="height: 100%;">
                  <div slot="header">
                    <span class="mdoelT">Wheat Prediction</span>
                  </div>
                  <div>
                    <h3 style=" text-align: justify; font-family: 'Times New Roman';">
                      Here we provide a training model based on data from the wheat "Chinese Spring" material for prediction.
                      <br>(1) Use the chromatin interaction data of wheat root tissue in the cuttings of "China Spring" to predict the expression of related genes and provide a prediction model;
                      <br>(2) The length of the chromatin interaction sequence of the input gene is 3kb
                    </h3>
                    <div>
                      <el-select
                        style="width: 240px"
                        placeholder="-----Select Sample-----"
                        @change="dataChange"
                        v-model="dataCate"
                      >
                        <el-option
                          v-for="value in dataCateOp"
                          :key="value"
                          :value="value"
                        >
                          {{ value }}
                        </el-option>
                      </el-select>
                    </div>
                    <h3 style="color: #fb6672; font-weight: bold">
                      Please select Wheat models
                    </h3>
                    <el-select
                      style="width: 240px"
                      placeholder="-----Select Model-----"
                      @change="WheatchangeTools"
                      v-model="Wheatmodel"
                      :disabled="!modelflag"
                    >
                      <el-option
                        v-for="value in modellist"
                        :key="value"
                        :value="value"
                      >
                        {{ value }}
                      </el-option>
                    </el-select>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="8">
                <el-card style="height: 100%;">
                  <div slot="header">
                    <span class="cardTitle">Note</span>
                  </div>
                  <div>
                    <p style="font-size: 15px;text-align: justify; font-family: 'Times New Roman';">
                    (1) We provide two ways to input sequences: online input and local upload;
                    <br>(2) The above two input methods must satisfy the form of the input interactive pair (see example below);
                    <br>(3) In both input methods, the standard fasta format sequence is required to be input;
                    <br>(4) In order to send you the real-time status of your homework, the email option below is required.
                    <br>(5) GWI: Genome-wide interaction
                      <br>
                      Friendship link : <a href="https://figshare.com/articles/dataset/Gossypium_anomalum_B1_genome/17280074" target="_blank" >Gossypium</a>
                    </p>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-tabs
              v-if="dataCate !== 'GWI Prediction'"
              tab-position="top"
              stretch
              @tab-click="methodsChange"
              value="input"
              style="margin-top: 40px; margin-bottom: 20px"
            >
              <!-- 选择模型输入序列 -->
              <el-tab-pane name="input">
                <span slot="label" class="tabLable"
                  ><i class="el-icon-edit"></i> Manual input</span
                >
                <div>
                  <div class="tipsButton">
                    <el-popover
                      placement="top"
                      width="500"
                      trigger="hover"
                      :open-delay="100"
                    >
                      <h2 style="text-align: center; margin: 0 auto">
                        Right example
                      </h2>
                      <el-input
                        type="textarea"
                        style="width: 95%; margin: 10px"
                        :value="exampleSeq"
                        rows="10"
                        :readonly="true"
                      />
                      <el-button
                        slot="reference"
                        class="el-icon-info"
                        ref="dataBu"
                      >
                        First : Correct data format</el-button
                      >
                    </el-popover>
                    <div class="ToolButton" style="display: flex">
                      <el-button
                        icon="el-icon-s-data"
                        @click="updataEx"
                        style="margin: 0 auto"
                        :disabled="!seqflag"
                        >Example</el-button
                      >
                    </div>
                  </div>
                  <div>
                    <el-input
                      type="textarea"
                      style="width: 47%; margin: 10px"
                      :autosize="{ minRows: 8, maxRows: 16}"
                      v-model="Seq1"
                      :disabled="!seqflag"
                      rows="4"
                      placeholder="Please select the model from above first"
                      @blur="checkinput(1)"
                    />
                    <el-input
                      type="textarea"
                      style="width: 47%; margin: 10px"
                      :autosize="{ minRows: 8, maxRows: 16}"
                      v-model="Seq2"
                      :disabled="!seqflag"
                      rows="4"
                      placeholder="Please select the model from above first"
                      @blur="checkinput(2)"
                    />
                  </div>

                </div>
              </el-tab-pane>
              <!-- 或者直接上传文件 -->
              <el-tab-pane name="file">
                <span slot="label" class="tabLable"
                  ><i class="el-icon-folder-add"></i> Upload files</span
                >
                <el-row style="text-align: center">
                  <el-col :span="24" style="margin-top: 10px">
                    <div>
                      <h1
                        v-if="!seqflag"
                        style="color: #fb6672; font-weight: bold"
                      >
                        👆👆👆 Please select the model from above first
                      </h1>
                      <h1
                        v-if="fileFlag"
                        style="color: #47b347; font-weight: bold"
                      >
                        Successfully uploaded the file
                      </h1>
                    </div>
                    <el-upload
                      class="upload-demo"
                      drag
                      action=""
                      multiple
                      :on-change="fileChange"
                      :file-list="fileList"
                      :auto-upload="false"
                      accept=".fasta"
                      :disabled="!seqflag"
                      :limit="1"
                    >
                      <div v-if="seqflag">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                          Drop files here, Or <em>Click Upload</em>
                        </div>
                      </div>
                      <div v-else>
                        <!-- <i class="el-icon-upload" style="color:#d32f2f"></i> -->
                        <span
                          class="iconfont icon-jinyong"
                          style="font-size: 70px; color: #d32f2f"
                        ></span>

                        <div class="el-upload__text">
                          You haven't selected the model from above
                        </div>
                      </div>

                      <div class="el-upload__tip" slot="tip">
                        Only .fasta files can be uploaded
                      </div>
                    </el-upload>
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
            <pdiComponent
              v-else
              ref="pdiComponentRef"
              :resetKey="componentKey"
            ></pdiComponent>
            <!-- 输入邮箱 -->
            <el-row type="flex" justify="center">
              <el-col :span="12" style="margin-top: 10px">
                <el-form :model="updataForm" ref="updataForm">
                  <el-form-item
                    prop="email"
                    label-width="100px"
                    :rules="[
                      {
                        required: true,
                        message: 'Please enter the email address',
                        trigger: 'blur',
                      },
                      {
                        type: 'email',
                        message: 'Please enter the correct email address',
                        trigger: ['blur'],
                      },
                    ]"
                  >
                    <span slot="label" style="font-size: 20px;width: 600px;"> E-mail: </span>
                    <el-input v-model="updataForm.email"></el-input>
                  </el-form-item>
                  <el-form-item
                  prop="verify"
                  label-width="200px"
                  :rules="[
                    {
                      required: true,
                      message: 'Please enter the Verify code',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <span slot="label" style="font-size: 20px">Enter the number: </span>
                  <div style="display: flex;">
                    <el-input
                  v-model="inputCaptcha"
                ></el-input>
                <img
                  :src="captchaImg"
                  alt=""
                  @click="reflshCaptch"
                  style="cursor: pointer;margin-left: 20px;"
                />
                  </div>

                </el-form-item>
                </el-form>
              </el-col>
            </el-row>
            <!-- 提交 -->
            <el-row v-if="dataCate !== 'GWI Prediction'" type="flex" justify="center">
              <div class="ToolButton">
                <el-button
                  style="margin-top: 6px"
                  type="primary"
                  icon="el-icon-s-promotion"
                  @click="submitInputSeq"
                >
                Submit
                </el-button>
                <el-button
                  type="danger"
                  icon="el-icon-refresh-right"
                  @click="resetInfo"
                  >Reset</el-button
                >
              </div>
            </el-row>
            <el-row v-else type="flex" justify="center">
            <div class="ToolButton">
              <el-button
                style="margin-top: 6px"
                type="primary"
                icon="el-icon-s-promotion"
                @click="submitPdiComponent"
              >
                Submit
              </el-button>
              <el-button
                type="danger"
                icon="el-icon-refresh-right"
                @click="resetPdiComponentInfo"
                >Reset</el-button
              >
            </div>
          </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { Message } from "element-ui";
import pdiComponent from "./pdiComponent.vue";
export default {
  name: "Wheat",
  components: {
    pdiComponent
  },
  data() {
    return {
      list1: [],
      InputSeqs: "",
      loading: true,
      isShowImg: false,
      fileList: [],
      componentKey: "",
      Seq1: "",
      Seq2: "",
      uploading: false,
      modellist: ["Root(Lorenzo Concia et al. 2020)"],
      options: [{ value: "1" }, { value: "2" }],
      updataForm: {
        email: "",
        verify:""
      },
      Wheatmodel: "Root(Lorenzo Concia et al. 2020)",
      // PDImodel: undefined,

      // 当前进行到第几步
      steps1: 0,
      // 表示使用的是哪种方法。0为手动，1为上传
      method: 0,
      // 检查两种数据是否校验成功
      inputFlag: false,
      fileFlag: false,

      taskBoby_seq: {
        modelName: "",
        data: [],
        email: "",
        uuid: undefined,
        captcha: undefined,
      },
      taskBoby_file: {
        modelName: "",
        email: "",
        uuid: undefined,
        captcha: undefined,
      },
      uuid: undefined,
      captchaImg: "",
      inputCaptcha: undefined,
      EXseq1:
        ">TraesCS1A02G000200\n" +
        "GATCTTCTGTGAAGGGTTTGAGTTGGAGCACGCCTGTCGGGACTCGAAAGATGGTGAACTATGCCTGAGCGGGGCGAAGCCAGAGGAAACCCTGGTGGAGGCTCGAAGCGATACTGACGTGCGAATCGTTCGTCTGACTTGGGTATAGGGGCGAAAGACTAATCGAACCATCTAGTAGCTGGTTCCCTCAGAAGTTTCCCTCAGGATTGCTGGAGCCCATTACGAGTTCTATCAGGTAAAGCCAATGATTAGAGGCATCGGGGACGCAACATCCTCGACTTATTCTCAAACTTTAAATAGGTAGGATGGTGCGGCTGCTTCGGTGAGCCGTGCCACGGAATCGGGTGCTCCAAGTGGGCCATTTTTGGTAAGCAGAACTGGCGATGCGGGATGAACCGAAAGCCAGGTTACGGTGCCCAACTGCGCGCTAACCTAGAACCCACAAAGGGTGTTGGTCGATTAAGACAGCAGGACGGTGGTCATGGAAGTCGAAATCTGCTAAGGAGTGTGTAACAACTCACCTGCCGAATCAACTAGCCCCGAAAATGGATGGCGCTGAAGCGCGCGACCCACACCCGGCCATCTGGTGGTAGTAGCAAATATTCAAATGAGAACTTTGAAGGCCGAAGAGGAGAAAGGTTCCATGTGAACGGCACTTGCACATGGGTAAGCCGATCCTAAGGGACGGGGTAACCCCAGCAGATAGCGCGATCACGCGCATCCCCCGAAAGGGAATCGGGTTAAGATTTCCCGACTGGGATGTGGCGGTTGACGGTGACGTTAGGAAGTCTGGAGACGCCGGTGGGGGCCTCGGGAAGAGTTATCTTTTCTGCTTAACGGCCTGCCAACCCTGGAAACGGTTCAGCCGGAGGTAGGGTCCAGTGGGCGGAAGAGCACCGCACGTCGCGAGGTGTCCGGTGCGCCCCCGGCGGCCCATGAAAATCCGGAGGACCGAGTACCGTTCATGCCCGGTCGTACTCATAACCGCATCAGGTCTCCATGGTGAACAACCTCTGGCCAATGGAACAATGTAGGCAAGGGAAGTCGGCAAAACGGATCCGTAACTTCGGGAAAAGGATTTGCTCTGAGGACTGGGCTCAGGGGTCCCGGCCCCGAACCCGTCGGCTGTCGGCAGATTGCTCGTGTTGCTCACGCGGCAAGAGCAGGTCGCCGCGTGCCGGCCAGGGGACGGACCAGGAATCGCCCCTTCGGGGGCTTTCCCCGAGCATGAAACAGTCGACTCAGAACTGGTACGGACAAGGGGAATCCGACTATTTAATTAAAACAAAGCATTGCGATGGTCCTCGCGGAAACTGACGCAATGTGATTTCTGCCCAGTGCTCTGAATGTCAAAGTGAAGAAATTCAACCAAGCGCGGGTAAACGGCGGGAGTAACTATGACTCTCTTAAGGTAGCCAAATGCCTCGTCATCTAATTAGTGACGCGCATGAATGGATTAACGAGATTCCCACTATCCCTGTCTACTATCCAGCGAAACCATGAAGCTAGAGGTGTTAGAAAAGTTACCACAGGGATAACTGGCTTGTGGCAGCCAAGCGTTCATAGCGACGTTGCTTTTTGATCCTTCGATGTCGGCTCTTCCTATCATTGTGAAGCAGAATTCACCAAGTGTTGGATTGTTCACCCACCAATAGGGAATGTGAGCTGGGCTTAGACCGTCATGAGACAGGTTAGTTTTACCCTACTGATGACAGTGTCGCGATAGTAATTCAACCTAGTACGAGAGGAACCGTTGATTCACACAATTGGTCATCGCGCTTGGTTGAAAAGCTAGTGGCGCGAAGCTACCGTGTGCTGGATTATGACTGAACGCCTCTAAGTCAGAATCCAAGCAAGCATGCGACGCCTGCGCCCGCCGCCCACCCCGACCCACGTTAGGGGCGCTTGTGCCCCCAAGGGCCCGTGCCATTGGCTAAGCCGGTCCGGCTGACGTGTCGTGGCCGGCCGCCTCGAAGCTTCCTTCCCAACGGGCGGTGGGCTAAATCCTTTGCAGATGACTTAACTACGCGACGGGGCATTGTAAGTGGTAGAGTGGCCTTCCTGCCATGATCCACTGAGATCCAGCCCCATGTCGCACGGATTCGTCCCTCCCCCACACCTCTCCTTCATCCACTTAGGTTCAGATGCTACAACAAAATTCTACATGCCTAAGTCATGGTGAAAAGAAATGGAAAACACGATTCATGTGTATGCCATCGTCACAGGCTACACGGACCCGTAACGGGTGGTATGAGACAAGGGAAAAAAGTTCCTGAAGCCCGTCGTGGACGGAGCTGGACACGCGCCATGGAAAACATGGCAAAAGCATATACAATTCCACGATCCGTACACGGACCCAGACACGTACCCAGATGGGCGGTACGGGGACACGGGAAAAAAAGTTCCCGACGCCCGTCGTGGACGGAGCTGCACGCGTGCCATGGAAAACAGGGCAAAAGCACAGACGATTCCATGATACGTACNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN\n"+
        ">TraesCS1A02G000300\n" +
        "AAGAGAGTCAAATAGTGCTTGAAATTATCGGGAGGGAAGCGGATGGGGGCCGACGATGCGCCCCGGCCGTATGCGGAACGGCTCTTGCTGGTCCGCCGCTCGGCTCGGGGTGTGGACTGTTGTCGGTCGTGCCGGCGGCCAAAGCCCGGGGGCCCTAGGTGCCCCCGGTGGCCGTCGTCGGCACGGCAGGTACCCGCGCGCTAAAAGGCGTGTCCCTCGAGGTACTGCGCTGCAATGGCCTGCGGGCTCCCCATCTGACCCGTCTTGAAACACGGACCAAGGAGTCTGACATGCGTGCGAGTCGACGGGTTCTGAAACCTGGGATGCGCAAGGAAGCTGACGAGCGGGAGGCCCTCACGGGCCGCACCGCTGGCCGACCCTGATCTTCTGTGAAGGGTTCGAGTTGGAGCATGCCTGTCGGGACCCGAAAGATGGTGAACTATGCCTGAGCGGGGCGATGCCAGAGGAAACTCTGATGGAGGCTCGAAGCGATACTGACGTGCAAATCGTTCGTCTGACTTGGGTATAGGGGCGAAAGACTAATCGAACCATCTAGTAGCTGGTTCCCTCCGAAGTTTCCCTCAGGATAGCTGGAGCCCATTACGAGTTCTATCAGGTAAAGCCAATGATTAGAGGCATCGGGGACGCAACGTCCTCGACCTATTCTCAAACTTTGAATAGGTAGGATGGCGCGGCTGCTTCGGTGAGCCGTGACACGGAATCGGGTGCTCCAAGTGGGCCATTTTTGGTAAGCAGAACTGGCGATGCGGGATGTACCGGAAGCCGGGTTACGGTGCCCAACTGCGCGCTAACCTAGAACCCACAAAGGGTGTTGGTCGATTAAGACAGTAGGATGGTGGTCATGGAAGTCGAAATCCGCTAAGAAGTGTGTAACAACTCATATGCCGAATCAACTAGCCCCGAAAATGGATGGCGCTGAAGCGCGCGACCCACACCCGGCCATCTGGGCGAGCGCCATGCCCCGATGAGTAGGAGGGCGTGGCGGCCGCTGCAAAACCCGGGGCGCGAGCCCGGGCGGAGCGGCCGTCGGTGCAGATCTTGGTGGTAGTAGCAAATATTCAAATGAGAACTTTGAAGGCCGAAGAGGAGAAAGGTTCCATGTGAACGGCACTTGCACATGGGTAAGTCGATCCTAAGTGACGGGGTAACCCTGGCAGATAGCGCGATCACGTGCATCCCCCGAAAGGGAATCGGGTTAAGATTTCCCGAGCCGGGATGTGGCGGTTGACTGCGACGTTAGGAAGTCCGGAGACGCCGGCGGGGGCCTCGGGAAGAGTTATCTTTTCTGTTTAACGGCCTGCCAACCCTGGAAACGGTTCAGCCGGAGGTAGGGTCCAGTGGCCGGAAGAGCACCACACGTCGCGCGTTGTCCGGTGCGCCCTCGGCGGCCCATGAAAATCCGGAGGACCAAGTACCGTTCACGCCCGGTCGTACTCATAACCGCATCAGGTCTCCAAGGTGAACAGCCTCTGGCCAATGGAGTTATCTTTTCTGCTTAACGGCCTGCCAACCCTGGAAACGGTTCAGCCGGAGGTAGGGTCCAGTGGCCGGAAGATCACCGGACGTCGCGCGGTGTCCAGTGCGCCCCCGGCGGCCCATGAAAATCCGGAGGACCGAGTACCGTTCACACCCGGTCGTACTCATAACCGCATCAGGTCTCCAAGGTGAACAGCCTCTGGCCAATGGAACAATGTAGGCAAGGGAAGTCGGCAAAACGGATCCGTAACTTCGGGAAAAGGATTGGCTATGAGGACTGGGCTCGGGGGTCCCGGCCCCGAACCCGTCGGCTGTCGGCGGATTGCTCGAGCTGCTCACGCGGCGAGAGCGGGTCGCCGCATGCCGGCCGGGGGACGGACCGGGAATCGCCCCTTCGGGGGCTTTCCCTGAGCATGAAACAGTCAACTCAGAACTGGTACGAACAAGGGGAATCCGACTGTTTAATTAAAACAAAGCATTGTGATGGTCCTCGCGGATGCTGACGCAATGTCAAAGTGAAGAAATTCAACCAAGCGCGGTAAACGGCGGGAGTAACTATGACTCTCTTAAGGTAGCCAAATGCCTCGTCATCTAATTAGTGACGCACATGAATGGATTAACGAGATTCCCACTGTCCCTGTCTACTATCCAGCGAAACCACAACCAAGGGAACGGGCTTGGCGGAATCAGCGGGGAAAGAAGACCCTGTTGAGCTTGACTCTAGTCCGACTTTGTGAAATGACTTGAGAGGTGTAGGATAAGTGGGATCCCTCACGGGCGCAAGTGAAATACCACTACTTTTAACGTTATTTTACTTATTCCGTGGGTCGGAAGCGGGGCATGTCCCCTCCTTTTGGCTCCAAGGCCCGGTCTTACCGGGCCGATCCTGGCAGAAGACATTGTCAGGTGGGGAGTTTGGCTAGGGCGGCACATCTGTTAAAAGATAACGCAGGTGTCCTAAGATGAGCTCAACGAGAACAGAAATCTCGTGTGGAACAAAAGGGTAAAAGCTCGTTTGATTCTGATTTCCAGTACGAATACGAACCGTGAAAGCGTGGCCTATCGATCCTTTAGATCTTCGGAGTTTGAAGCTAGAGGTGTCAGAAAAGTTACCACAGGGATAACTGGATTGTGGCAGCCAAGCGTTCATAGAGACGTTGCTTTTTGATCCTTCGATGTCGGATCTTCCTACCATTGTCAAGCAGAATTCACCAAGTGTTGGATTGTTCACCCACCAATAGGGAACGTGAGCTGGGTTTAGACCGTCGTGAGACAGGTTAGTATTACCGTACTGATGACAGTGTCGCGATAGTAATTCAACCTAGTACGAGAGGAACCGTTGATTCACACAATTGGTCATCGCGCTTGGTTGAAAACCCAGTGGCGCGAAGCTACCGTGTGCCGGATTATGGCTGAACGCCTCTAAGTCAGAATCAAAGCTAGCATGCGATGCCTGCGCCCGCCGCCTGCCCCGACCCACGTTAGGGGCGCTTGCGCCCCCAA\n",
      EXseq2:
        ">TraesCS1A02G000400\n" +
        "CCGTTTAGGCGACGAAAGTTTGAGGCAATAATAGGTCTGTGATGCCCTTAGATGTTCTGGGCTGCACGCGCGCTACACTGATGTATTCAACTAGTATTTAGCCTTGGCCGACAGGCCCGGGTAATCTTGGGAAATTTCATCGTGATGGGGATAGATCATTGCAATTGTTGGTCTTCAACGAGGAATGCCTAGTAAGCGCGAGTCATCAGCTCGCGTTGACTACGACCCTGCCCTTTGTAGACACCGCCCGTCGCTCCTACCGATTGAATGGTCCGGTGAAGTGTTCGGATCGCGGCGACGGGGGTGGTTCGCCACCCCCGACGTCGCGAGAAGTCCATTGAACCTTATCATTTAGAGGAAGGAGAAGTCGTAACAAGGTTTGCGTAGGTGAACCTGCGGAAGGATCATTGTCGTGACCCTGACCAAAACAGACCGTGCACGCGTCATCCAATCCGTCGGCGACGGCATTGTCCGTCGCTCGGCCAATGCCTCGACCACCTCCCCTCCTCGGAGTGGGTGGGGGCTCGGGATAAAAGAACCCACGGCACCGAAGGcGTCAAGGAACATTGTGCCTAACCCGGGGGCATGGCTAGCTTGCTAGTCATCCCTCGTGTTGCAAAGCTATTTAATCCACACGACACTCGGCAACGGATATCTCGGCTCTCGCATCGATGAAGAACGTAGCGAAATGCGATACCTGGTGTGAATTGCAGAATCCCGTGAACCATCGAGTCTTTGAATGCAAGTTGCGCCCGAGGCCACTCGGCCGAGGGCACGCCTGCCTGGGCGTCACGCCAAAACACGCTCCCAACCCCCTCATCAGGAATCAGGATGTGGCATCTGGTCCCTCGTTTCGCAAGGGGCGGTGGACCGAAGATCAGGCTGCCGGCGTACCGCGCCGGACACAGCGCATGGTGGGCGTCCTCGCTTTATCAACGCAGCGCATCCGACGCGCAGCCGGCATGATGGCCTCAAAATGACCCAGCAAACGAAGCACACGTCGCTTCGACCGCGACCCCAGGTCAGGCAGGACTACCCGCTGAGTTTAAGCAGATAAATAAGCGGAGGAGAAGAAACTTACAAGGATTCCCCTAGTAACGACGAGCGAACCGGGAGCAGCCCAGCTTGAGAATCGGGCGGCTGTGCCATCCGAATTGTAGTCTGGAGAGGCGTCCTCAGCGACGGACCGGGCCAAAGTCCCCTGGAAAGGGGCGCCTGGGAGGGTGAGAGCCCCATCCGGCCCGGACCCTGTCGCCCCACGAGGCGCCGTCAACGAGTCGGGTTGTTTGGGAATGCAGCCTAAATCGGGCGGTAGACTCCGTCCAAGGCTAAATACAGGCGAGGGACCGATAGCGAACAAGTACCGCGAGGGAAAGATGAAAAGGACTTTGAAAAGAGAGTCAAAGAGTGCTTGAAATTGCCGGGAGGGAAGCGGATGGGGGCCGGCGATGCGCCCCGCCCGTATGCGGAACGGCTCTTGCTGGTCCGCCGCTCGGCTCGGGGCGGCACATCTGTTAAAAGATAATGCAGGTGTCCTAAGATGAGCTCAACGAGAACAGAAATCTCGTGTGGAACAAAAGGGTAAAAGCTCGTTTGATTCTGATTTCCAGTACGAATACGAACCGTGAAAGCGTGGCCTATCAATCCTTTAGATCTTCAGAGTTTGAAGCTAGAGGTGTCAGAAAAGTTACCACAGGGATAACTGGCTTGTGGCAGCCAAGCGTTCATAGCGACGTTGCTTTTTGATCCTTCGATGTCGGCTCTTCCTATCATTGTGAGGCAGAATTCACCAAGTGTTGGATTGTTCACACACCAATAGGGAACGTGAGCTGGGTTTAGACCATCGTGAGCCAGGTTAGTTTTACACTACTGATGACAGTGTCGTGATAGTAATTCAACCTAGTACGAGAAGAACCGTTGATTCACACAATTGGTCATCGCGCTTGGTTGAAAAGCCAGTGGCGCGAAGCTACCGTGTGCCCGATTATGACTGAACGCCTCTAAGTCAGAATCCAAGCTAGCATGCGACGCCTGCGCCCGCCGCCCGCCCTGACCCAAGTTAGGGGCGCTTGCGCCCCCAAGGGCCCATGCCATTGGCTAAGCCGGTCCGGCCGACATGCCGCGGCCGACCGCCTCGAAGCTCCCTTCCCAACGGGCGGTGGGCTGAATCCTTTGCAGACGACTTAAATACGCGACGGGGGATTGTAAGTGGCAAAGTGGCCTTGCTGCCACGATCCACTGAGATCCAGCCCCATGTCGCACGGATTCATCCCTCCCCCACACCTCTCCTTCATCCACTTAGGTTCAGATGCTACAACAAAATTCTACATGCCTAAGTCATGGTGAAAAGAAATGGCAAACACGATTCATGTGTATGCCATCGTCACAGGCTACACAGACCAGTAACGGGTGGTATGAGACAAGGGAAAAAAGTTCCCGACGCCCGTCGTGGACGGAGCTGCACCCGTGCCACGGAAAACAGGGCAAAAGCACAGACGATTCCATGATCCGTACACGGACCCAGACACGTACCCAGAACGGGCGGTACGGGGACACGGGAAAAAAAGTTCCCGACGCCCGTCGTGGACGGAGCTCCACCCTTGCCATGGAAAACAGGGCAAAAGCACAGACGATTCCACGATCCGTACACGGACCCAGACACGTACCCAAAACNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN\n"+
        ">TraesCS1A02G000600\n" +
        "CCAAGGAAGGCAGCAGGCGCGCAAATTACCCAATCCTGACACGGGGAGGTAGTGACAATAAATAACAATATCGGGCGCATTAGTGTTTGGTAATTGGAATGAGTACAATCTAAATCCCTTAACGAGGATCCATTGGAGGGCAAGTCTGGTGCCAGCAGCCGCGGTAATTTAGAACGTGGATGGTGCAGATGGTGCGGCTGCTTCGGTGAGCCGTGCCACGGAATCGGGTGCTCCAAGTGGGCCATTTTTGGTAAGCAGAACTGGCGATGCGGGATGAACCGGAAGCCAGGTTACGGTGCCCAACTGCGCGCTAACCTAGAACCCACAAAGGGTGTTGGTCGATTAAGACAGCAGGACGGTGGTCATGGAAGTCGAAATCCACTAAGGAGTGTGTAACAACTCACCTGCCGGATCAACTAGCCCCAAAAATGGATGGCGCTGAAGCGCGCGACCCACACCCGGCCATCAGGGCGAGCGCCATGCCCCGATGAGTAGGAGGGCGCGGCGGCTACTGCAAAACCGGGGGCGCGAGCCCGGGCGGAGCGGCCGTCGGTGCAGATCTTGGTGGTAGTAGCTAATATTCAAATGAGAACTTTGAAGGCCGAAGAGGAGAAAGGTTCCATGTGAACGGCACTTGCACATGGGTAAGCCGATCCTAAGGGACGGGGTAACCCCGGCAGATAGCGCGATCACGCGCATCCCCCGAAAGGGAATCGGGTTAAGATTTCCCGAGCCGGGATGTGGCGGTTGACGGTGACGTTAGGAAGTCCGGAGACGTCGGCGGGGGCGTCAGGAAGAGTTATATTTTCTACTTAACGGCCTGCCAACCCTGGAAACGTTTCAGCCGGAGGTAGGGTCCAGTGGCCGGAAGAGCACCGCACGTCGCGCGGTGTCCGGTGCGCCCCCGGCGGCCCATGAAAATCCGGAGGACCGAGTACCGTTCACACTCGGTCGTACTCATAACCGCATCAGGTCTCCAAGGTGAACAGCCTCTGGACAATGGAACAATGTAGGCAAGGGAAGTCGGCAAAACGGATCCGTAACTTCGGGAAAAGGATTGGCTCTGAGGACTGTGCTCGGGGGTCCCGGCCCCGAACCCGTCGGCTGTCGGCGGATTGCTCGAGCTGCTCACGCGGCGAGAGCGGGTCGCTGCTTGCCGGCCGGGGGACGGACCGGGAATCGCCCCTTCGGGGGCTTTCCCCGAGCATGAAACAGTCGACTCAGAACTGGTACGGACAAGGGGAATCCGACTGTTTAATCAAAACAAAGCATTGCGATGGTCCTCGCGGATGCTGACGCAATGTGATTTCTGCCCAGTGCTCCGAATGTCACAGTGAAGAAATTCAAGCAAGTGCGGGTAAACGGCGGGAGTAACTATGACTCTCTTAAGGTAGCCAAATGCCTCGTCATCTAATTAGTGACGCGCATGAATGGATTAACGAGATTCCCACTGTCCCTGTGTACTATCCAGCGAAACCACAGCCAAGGGAACGGGCTTGGGAGTTATATTTTCTACTTAACGGCCTGCCAACCCTGGAAACGTTTCAGCCGGAGGTAGGGTCCAGTGGCCGGAAGAGCACCGCACGTCGCGCGGTGTCCGGTGCGCCCCCGGCGGCCCATGAAAATCCGGAGGACCGAGTACCGTTCACACTCGGTCGTACTCATAACCGCATCAGGTCTCCAAGGTGAACAGCCTCTGGACAATGGAACAATGTAGGCAAGGGAAGTCGGCAAAACGGATCCGTAACTTCGGGAAAAGGATTGGCTCTGAGGACTGTGCTCGGGGGTCCCGGCCCCGAACCCGTCGGCTGTCGGCGGATTGCTCGAGCTGCTCACGCGGCGAGAGCGGGTCGCTGCTTGCCGGCCGGGGGACGGACCGGGAATCGCCCCTTCGGGGGCTTTCCCCGAGCATGAAACAGTCGACTCAGAACTGGTACGGACAAGGGGAATCCGACTGTTTAATCAAAACAAAGCATTGCGATGGTCCTCGCGGATGCTGACGCAATGTGATTTCTGCCCAGTGCTCCGAATGTCACAGTGAAGAAATTCAAGCAAGTGCGGGTAAACGGCGGGAGTAACTATGACTCTCTTAAGGTAGCCAAATGCCTCGTCATCTAATTAGTGACGCGCATGAATGGATTAACGAGATTCCCACTGTCCCTGTGTACTATCCAGCGAAACCACAGCCAAGGGAACGGGCTTGGCGGAATCAGCGGGGAAAGAAGACCCTGTTGAGCTTTACTCTAGTCCGACTTTGTGAAATGACTTGAGAGGTGTAGGGTAAGTGGGAGCCCTCACGGGCGCAAGTGAAATAGCACTACTTTTAACATTATTTTACTTATTCCGTGGGTCGGAAGCGGGGCATGTCCCCTCCTTTTGGCTCCAAGGCCCGGTCTTACTGGGCCGATCCGGGCGGAAGACATTGTCAGGTGGGGAGTTTGGCTAGGGCGGCTCATCTGTTAAAAGATAACGCAGGTGTCCTAAGATGAGCTCAACGAGAACAGAAATCTCGTGTGGAACAAAAGGGTAAAAGCTCGTTTGATTCTGATTTCCTGTACGAATACGAACCGTGAAAGCGTGGCCTATCGATCCTTTAGATCTTAAGAGTTTGAAGCTAGGGTTGTCAGAAAAGTTACCACAGGGATAACTGGCTTGTGGCAGCCAAGCGTTCATAGCGACGTTGCTTTTTGATCCTTCGATGTCAGCTCTTCCTATCATTGTGAAGCAGAATTCACCAAGTGTTGGATTGTTCACCCACCAATAGGGAACGTGAGCTGGGTTTAGACCGTCGTGAGACAGGTTAGTTTTACCCTACTGATGACAGTGTCGCGATAGTAATTCAACCTAGTACGAGAGGAACCGTTGATTCACACAATTGGTCATCGCGCTTGGTTGAAAAGCCAGTGGCGCGAAGCTACCGTGTGCCGGATTATGACTGAATGCCTCTAAGTCAGAATCCAAGCTAGCATGCGACGCCTGCGCCCGCCGCCAGCCCCGACC\n",

      dataCate: "",
      dataCateOp: ["Wheat_PPI_Prediction","Wheat_PDI_Prediction","GWI Prediction"],
    };
  },
  computed: {
    // 输入的序列长度
    seqlenth() {
      return 3000;
    },
    // seqflag 用来表明序列是否可以输入
    seqflag() {
      if (this.Wheatmodel) return true;
      else return false;
    },
    modelflag() {
      if (this.dataCate) return true;
      else return false;
    },
    exampleSeq(){
      return this.EXseq1
    },
    exampleSeq1(){
      return this.EXseq2
    }
  },
  watch:{
        inputCaptcha(newName, oldName){
           this.updataForm.verify=newName
        }
  },
  methods: {
    async submitPdiComponent() {
      try {
        await this.$refs.pdiComponentRef.validateForm();
        let data = this.$refs.pdiComponentRef.getData();
        let params = {
          email: this.updataForm.email,
          project: "gowheat",
          modelName: "genome",
          gdata: data,
        };
        let result = await this.$API.reqAllSubmitData(params);
        if (result.code === 200) {
          this.$router.push("/search");
        } else {
          this.$message.error(result.msg);
        }
      } catch (error) {
        console.log("Validation failed");
      }
    },
    resetPdiComponentInfo() {
      this.$refs.pdiComponentRef.resetForm();
    },
    dataChange() {
      this.resetInfo();
      if(this.dataCate === 'GWI Prediction') {
        this.modellist = ["Genomic region"]
        this.componentKey = "wheat";
      } else {
        this.modellist = ["Root(Lorenzo Concia et al. 2020)"]
        this.componentKey = "";
      }
    },
    confirmtype() {
      this.loading = !this.loading;
      console.log(this.methltype);
    },
    async reflshCaptch() {
      this.inputCaptcha = undefined;
      let result = await this.$API.reqCaptchaImg();
      if (result.code == 200) {
        this.captchaImg = "data:image/png;base64," + result.img;
        this.uuid = result.uuid;
      }
    },
    async getcaptch() {
      let flag = undefined;
      this.inputCaptcha = undefined;
      let result = await this.$API.reqCaptchaImg();

      if (result.code == 200) {
        this.captchaImg = "data:image/png;base64," + result.img;
        this.uuid = result.uuid;

        const h = this.$createElement;
        const inputElem = h(
          "input",
          {
            attrs: {
              value: this.inputCaptcha,
              id: "input1",
            },
            style: {
              width: "60%",
            },
            on: {
              input: function (event) {
                this.inputCaptcha = event.target.value;
              }.bind(this),
            },
          },
          ""
        );
        const imgElem = this.$createElement("img", {
          ref: "captchaImg",

          attrs: {
            src: this.captchaImg,
            // id: "captcha-img",
          },
          style: {
            "margin-top": "20px",
          },
          // 在这里。需要加上key才能保证el.msgbox每次都能渲染组件。
          // 详情见el官方文档。
          key: Date.now(),
        });

        // 将 input 和 img 元素放到 Vue 组件之外的 div 中
        const divElem = h("div", [inputElem, imgElem]);
        await this.$msgbox({
          title: "Please enter the verification code",
          message: divElem,
          type: "warning",
          center: true,
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Refresh",
          distinguishCancelAndClose: true,
          beforeClose: async (action, instance, done) => {
            // console.log(action);
            if (action === "confirm") {
              flag = true;
              done();
            } else if (action === "cancel") {
              let result = await this.$API.reqCaptchaImg();
              this.captchaImg = "data:image/png;base64," + result.img;
              this.uuid = result.uuid;

              this.$nextTick(() => {
                // 更新captchaImg元素的src属性

                // 在这里有两种解决方法，一种是使用ref，一种是使用id
                // 使用ref的话需要同时为元素绑定key属性
                this.$refs.captchaImg.src = this.captchaImg;
                // document.getElementById("captcha-img").src = this.captchaImg;
              });
            } else {
              flag = false;
              done();
            }
          },
        })
          .then((action) => {})
          .catch((action) => {});
      }
      // 返回的值代表用户是否提交了验证码
      if (this.inputCaptcha == undefined) flag = false;
      // 每次关闭后清空输入的验证码
      document.getElementById("input1").value = "";
      // console.log(flag);
      return flag;
    },

    // 新输入提交提交
    submitInputSeq() {
      // 先进行表单验证邮箱
      this.$refs.updataForm.validate(async (valid) => {
        if (valid) {
          // 如果是文件输入
          if (this.method == 1) {
            // 在这里进行数据整理并提交个服务器
            // 暂时直接显示成功
            // 判断步骤2是否成功
            if (this.fileFlag) {
              // let t = await this.getcaptch();

              // if (t != true) return;

              this.taskBoby_file.file = this.fileList[0].raw;
              this.taskBoby_file.email = this.updataForm.email;
              this.taskBoby_file.modelName = this.Wheatmodel + '.pkl';
              this.taskBoby_file.uuid = this.uuid;
              this.taskBoby_file.captcha = this.inputCaptcha;
              this.taskBoby_file.project = 'wheat';
              this.taskBoby_file.subtype = this.dataCate;
              this.taskBoby_file.sample = ''

              let result = await this.$API.reqSubmitFlie(this.taskBoby_file);

              if (result.code == 200) {
                this.steps1 = 3;
                this.$msgbox({
                  title: "Upload sequence succeeded!",
                  message:
                    "Your email will receive an email with a TASK NAME.\n \
                    Please query the progress of this task according to this TASK NAME",
                  type: "success",
                  confirmButtonText: "confrim",
                  callback: (action) => {
                    this.$router.go(0);
                  },
                });
              } else if (result.code == 500) {
                this.$msgbox({
                  title: "error!\n ",
                  message: "File processing error",
                  type: "error",
                  confirmButtonText: "confrim",
                });
              } else if (result.code == 400) {
                this.$msgbox({
                  title: "error!\n ",
                  message: "Verification code error",
                  type: "error",
                  confirmButtonText: "confrim",
                });
              }
            } else {
              this.$alert(
                "Please upload the correct fasta file",
                "Step 2 is not complete",
                {
                  confirmButtonText: "confrim",
                  type: "error",
                }
              );
              return;
            }
          }
          // 如果是手动输入
          else {
            // 判断步骤2是否成功
            if (this.inputFlag) {
              // let t = await this.getcaptch();
              // if (t != true) return;

              this.taskBoby_seq.data = [];

              var lenseq= this.Seq1.split("\n").length
              var seq1_list = this.Seq1.split("\n");
              var seq2_list = this.Seq2.split("\n");
              for(let i = 0; i <lenseq-1; i=i+2) {
                console.log(i)
                this.taskBoby_seq.data.push(seq1_list[i]+'\n'+seq1_list[i+1]);
                this.taskBoby_seq.data.push(seq2_list[i]+'\n'+seq2_list[i+1]);
                }

              this.taskBoby_seq.email = this.updataForm.email;
              this.taskBoby_seq.modelName = this.Wheatmodel + '.pkl';
              this.taskBoby_seq.uuid = this.uuid;
              this.taskBoby_seq.captcha = this.inputCaptcha;
              this.taskBoby_seq.project = 'wheat';
              this.taskBoby_seq.subtype = this.dataCate;
              this.taskBoby_seq.sample = ''

              let result = await this.$API.reqSubmitSeq(this.taskBoby_seq);
              if (result.code == 200) {
                this.steps1 = 3;
                this.$msgbox({
                  title: "Upload sequence succeeded!\n ",
                  message:
                    "Your email will receive an email with a TASK NAME.\n \
                    Please query the progress of this task according to this TASK NAME",
                  type: "success",
                  confirmButtonText: "confrim",
                  callback: (action) => {
                    this.$router.go(0);
                  },
                });
              } else if (result.code == 500) {
                this.$msgbox({
                  title: "error!\n ",
                  message: "File processing error",
                  type: "error",
                  confirmButtonText: "confrim",
                });
              } else if (result.code == 400) {
                this.$msgbox({
                  title: "error!\n ",
                  message: "Verification code error",
                  type: "error",
                  confirmButtonText: "confrim",
                });
              }
            } else {
              this.$alert(
                "Please enter the correct sequence and verify",
                "Step 2 is not complete",
                {
                  confirmButtonText: "confrim",
                  type: "error",
                }
              );
              return;
            }
          }
        } else {
          this.$msgbox({
            message: "please enter correct Email and Verify code",
            type: "error",
            confirmButtonText: "confrim",
          });
          return false;
        }
      });
    },

    WheatchangeTools(value) {
      this.steps1 = 1;

    },

    handlerSuccess(response, file, fileList) {},

    // 文件改变时监视，限制文件大小
    fileChange(file, fileList) {
      const isSize = file.size / 1024 / 1024;
      let lim = 0.5;
      if (isSize > lim) {
        this.$msgbox({
          message: "The file size exceeds the limit. MAX:500kb",
          type: "error",
          confirmButtonText: "confrim",
        });
        const currIdx = this.fileList.indexOf(file);
        this.fileList.splice(currIdx, 1);
        return;
      }

      this.fileList = fileList;
      this.steps1 = 2;
      this.fileFlag = true;
    },
    // 输入数据方法切换,清空另一个的内容
    methodsChange(tab, event) {
      if (tab.name === "input") {
        this.fileFlag = false;
        this.method = 0;
        this.fileList = [];
      } else if (tab.name === "file") {
        this.method = 1;
        this.inputFlag = false;
        this.Seq1 = "";
        this.Seq2 = "";
      }
    },

    isWheat(name){
        if(name.slice(0, 8) !='>TraesCS'||name.length!=19){
        return false
        }
      return true
      },

    checkSeq(seq1, seq2) {
      var seq1_list = seq1.split("\n");
      var seq2_list = seq2.split("\n");

      // 1:表示基因格式错误
      if (seq1_list.length % 2 != 0 || seq2_list.length % 2 != 0) return 1;
      // 2:表示两侧基因个数不一致
      if (seq1_list.length != seq2_list.length) return 2;

      // console.log(seq_list)
      for (var i = 0; i < seq1_list.length; i++) {
        if (i % 2 == 0) {
          if (seq1_list[i][0] != ">" || seq2_list[i][0] != ">") return 1;
          // 3表示交互的基因名重复了
          if (seq1_list[i] == seq2_list[i]) return 3;

          if(!this.isWheat(seq1_list[i])||!this.isWheat(seq2_list[i])) return 1;
        }
        if (
          i % 2 == 1 &&
          (!/^[ATCGNatcgn]+$/.test(seq1_list[i]) || !/^[ATCGNatcgn]+$/.test(seq2_list[i]))
        ) {
          return 1;
        }
      }
      // if(seq_list)
      return 0;
    },
    // 检查输入序列格式
    checkinput() {
      if (this.Seq2 != "" && this.Seq1 != "") {
        this.Seq1 = this.Seq1.trim();
        this.Seq2 = this.Seq2.trim();
        // 判断是否基因数过多
        var len1 = this.Seq1.split("\n").length;
        var len2 = this.Seq1.split("\n").length;
        if (len1 > 20 || len2 > 20) {
          this.$alert(
            "Maximum number of genes:20.If you want to upload more genes, please select File Upload ",
            "Too many genes!",
            {
              confirmButtonText: "confrim",
              type: "error",
            }
          );
          this.steps1 = 1;
          this.inputFlag = false;
          return;
        }

        var tem = this.checkSeq(this.Seq1, this.Seq2);
        var wrongBu = "";
        if (tem == 0) {
          this.steps1 = 2;
          this.inputFlag = true;
        } else if (tem == 1) {
          // this.$refs.dataBu[0].setAttribute("class", " wrongBu");
          Message({
            message:
              "Wrong data format !!! Please view the correct data format from above",
            type: "error",
            offset: 400,
          });
          this.steps1 = 1;
          this.inputFlag = false;

          wrongBu = "dataBu";
        } else if (tem == 2) {
          Message({
            message:
              "The number of genes in the two input boxes should be the same",
            type: "error",
            offset: 400,
          });
          this.steps1 = 1;
          this.inputFlag = false;

          wrongBu = "numBu";
        } else if (tem == 3) {
          Message({
            message:
              "The gene name of the interaction (that is, the gene name of the same line) cannot be the same",
            type: "error",
            offset: 400,
          });
          this.steps1 = 1;
          this.inputFlag = false;

          wrongBu = "nameBu";
        }
        if (wrongBu != "") {
          this.$refs[wrongBu].$el.classList.add("wrongBu");
          setTimeout(() => {
            this.$refs[wrongBu].$el.classList.remove("wrongBu");
          }, 3000);
        }
      }
    },
    // 清空已经填入的数据
    resetInfo() {
      this.Wheatmodel = "";
      // 手动输入
      if (this.method == 0) {
        this.inputFlag = false;
        this.Seq1 = "";
        this.Seq2 = "";
      }
      // 上传文件
      else {
        this.fileFlag = false;
        this.fileList = [];
      }

      this.updataForm.email = "";
      this.steps1 = 0;
    },

    updataEx() {
      this.Seq1 = this.EXseq1;
      this.Seq2 = this.EXseq2;

      this.steps1 = 2;
      this.inputFlag = true;
    },
  },
  created() {},
  mounted() {
    this.reflshCaptch();
  },
};
</script>
  <style scoped>
/* @import "../../assets/css/bootstrap.min.css";
  @import "../../assets/css/style.css"; */

.tool {
  /* height: 1500px; */
  /* margin-bottom: 50px; */
}
::v-deep .el-tabs__nav-scroll {
  width: 50%;
  margin: 0 auto;
}
::v-deep .el-tabs__item {
  font-size: 20px;
}
.tool-up {
  width: 70%;
  margin: 0 auto;
  background-color: #f4f4f4;
  padding-bottom: 40px;
  padding-top: 40px;
}

.top-text {
  text-align: center;
  margin: 0 auto;
  height: 70px;
  margin-bottom: 50px;
  /* background:-webkit-linear-gradient(left,#93a5cf,#e4efe9) ; */
  /* background: -webkit-linear-gradient(left, #fff1eb, #ace0f9); */
  border-radius: 8px;
}

th.column-money,
td.column-money {
  text-align: right !important;
}

.ToolButton button {
  font-size: 20px;
}

.ToolButton button:nth-child(2) {
  background-color: #ec971f;
  border-color: #ec971f;
}
.ToolButton button:nth-child(2):hover {
  background: #f0ad4e !important;
  border-color: #f0ad4e !important;
  color: #fff !important;
}

.cardTitle {
  margin-left: 10px;
  /* margin: auto; */
  font-size: 20px;
  /* color: #FA5F6F; */
}
.el-card ::v-deep .el-card__header {
  background-color: #a5ece4;
  /* border: #A5ECE4; */
}
.cardModel {
  width: 80%;
}

.cardModel ::v-deep .el-card__header {
  background-color: #18bc9c;
  /* border: #A5ECE4; */
}

.mdoelT {
  margin-left: 10px;
  /* margin: auto; */
  font-size: 25px;
  font-weight: bold;
}

.tipsButton {
  display: flex;
  margin: 0 auto;
  width: 40%;
  justify-content: space-evenly;
  align-items: center;
}

.wrongBu {
  color: #fff;
  background-color: #d32f2f;
  border-color: #d32f2f;
}

.tabLable {
  font-size: 25px;
  font-weight: bolder;
}
</style>
  